/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import {
    CONFIRMATION_TYPES,
    CONFIRMATION_BOX_BTN_IDS,
} from './confirmationDialogConstants';
import CONFIRMATION_CTAS_REPO from './confirmationDialogActionsRepo';
import {
    AppDialogAction, AppDialogDescription,
} from '../../../../stores/dialog';
import TranslationUtil from '../../../translation';
import { APP_DIALOG } from '../../../enums';

const getMessage = TranslationUtil.getMessage.bind(TranslationUtil);

const actionConfigMap = {
    primary: {
        text: 'ccx.confirmation.btn.continue',
        type: CONFIRMATION_BOX_BTN_IDS.PRIMARY,
    },
    secondary: {
        text: 'ccx.confirmation.btn.cancel',
        type: CONFIRMATION_BOX_BTN_IDS.SECONDARY,
    },
    tertiary: {
        text: 'ccx.confirmation.btn.cancel',
        type: CONFIRMATION_BOX_BTN_IDS.TERTIARY,
    },
};

const DIALOG_CONFIG = {};
DIALOG_CONFIG[CONFIRMATION_TYPES.PREV_VER_WITH_DISABLED_AU] = {
    heading: 'ccx.confirmation.prevVerDisableAU.title',
    desc: 'ccx.confirmation.prevVerEnableAU.desc',
};
DIALOG_CONFIG[CONFIRMATION_TYPES.DISABLE_AU_FOR_INSTALL] = {
    heading: 'ccx.confirmation.disableAUInstall.title',
    desc: 'ccx.confirmation.disableAUInstall.desc',
};
DIALOG_CONFIG[CONFIRMATION_TYPES.DISABLE_AU_FOR_UNINSTALL] = {
    heading: 'ccx.confirmation.disableAUUninstall.title',
    desc: 'ccx.confirmation.disableAUUninstall.desc',
};
DIALOG_CONFIG[CONFIRMATION_TYPES.PREV_VER] = {
    heading: 'ccx.confirmation.prevVerDisableAU.title',
    desc: 'ccx.confirmation.prevVerDisableAU.desc',
};
DIALOG_CONFIG[CONFIRMATION_TYPES.ELEVATION_INFO] = {
    heading: 'ccx.confirmation.elevationPromptInfo.title',
    desc: 'ccx.confirmation.elevationPromptInfo.desc',
};

class CommonDialogModelMapper {
    updateDialogRepo(confirmationType, appData) {
        const { heading, desc } = DIALOG_CONFIG[confirmationType];
        let {
            confirmationDetails: { confirmationButtons },
        } = appData;
        const {
            display_name: appName,
        } = appData;

        const version = appData.confirmationDetails.confirmationVersion;

        if (confirmationButtons
            && !Array.isArray(confirmationButtons)) {
            confirmationButtons = [confirmationButtons];
        }
        return {
            heading: getMessage(heading, { appName, version }),
            description: [
                new AppDialogDescription(
                    APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH,
                    getMessage(desc, { appName, version })
                ),
            ],
            actionList: confirmationButtons.reduce((actionList, { id }) => {
                const actionConfig = actionConfigMap[id];
                if (!id || !actionConfig) {
                    return actionList;
                }
                const localizedText = getMessage(actionConfig.text);
                actionList.push(
                    new AppDialogAction({
                        ...CONFIRMATION_CTAS_REPO[actionConfig.type],
                        localizedText,
                        ariaLabel: localizedText,
                        actionId: id,
                    })
                );
                return actionList;
            }, []),
        };
    }
}
export default new CommonDialogModelMapper();
